import { createApp } from "vue";

import 'maz-ui/css/main.css'

import 'vue-select/dist/vue-select.css';

import App from "./App.vue";
import store from "./store";
import keys from '@/store/keys'
import router from "./router";
import { apiInstance1, apiInstance2 } from "@/store/axios";
import PromSleep from '@/store/config';


import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import Toaster from '@meforma/vue-toaster';
import { vfmPlugin } from 'vue-final-modal'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { JSEncrypt } from 'jsencrypt'
import { Skeletor } from 'vue-skeletor';
import VLazyImage from "v-lazy-image";

import vSelect from "vue-select";
import "./registerServiceWorker";
import VueCleave from 'vue-cleave-component';
import Emittery from 'emittery';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import { toastMixin } from './mixins/toastMixin';
import globalMethods from './mixins/globalMethods';
import websocket from './plugin/websocket';

const encryptBackoffice = new JSEncrypt()
encryptBackoffice.setPublicKey(keys.publicKeyBackoffice);

const decryptBackoffice = new JSEncrypt();
decryptBackoffice.setPrivateKey(keys.privateKeyBackoffice);

const ua = navigator.userAgent


let isMobile = false;

if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
  console.log('Es mobile');
  //es mobile
  isMobile = true;
} else {
  console.log('Es desktop');
  //es destopk
  isMobile = false;

}


const appInstance = createApp(App);
appInstance.component('MazPhoneNumberInput', MazPhoneNumberInput)



const appFirebase = firebase.initializeApp({
  apiKey: "AIzaSyAW_nSJZYCy82oyfj9yuKgBD82oUWiO0BE",
  authDomain: "centromedico-iglesiaelguabo.firebaseapp.com",
  projectId: "centromedico-iglesiaelguabo",
  storageBucket: "centromedico-iglesiaelguabo.firebasestorage.app",
  messagingSenderId: "317442171468",
  appId: "1:317442171468:web:0cb98c850aad1969138ae9"
});



const auth = firebase.auth()
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)

appInstance.config.globalProperties.$appFirebase = appFirebase;

appInstance.config.globalProperties.$https = apiInstance1;
appInstance.config.globalProperties.$https2 = apiInstance2;
appInstance.config.globalProperties.$encryptBackoffice = encryptBackoffice;
appInstance.config.globalProperties.$decryptBackoffice = decryptBackoffice;



const promSleep = new PromSleep();
appInstance.config.globalProperties.$sleepTimer = promSleep;


const datosClinica = {
  lugar: 'DISPENSARIO MÉDICO PADRE EMILIO CATALÁN"',
  diocesis: 'Diócesis de Machala'
}

appInstance.config.globalProperties.$datosClinica = datosClinica;


appInstance.config.globalProperties.$isMobile = isMobile;
appInstance.config.globalProperties.$eventBus = new Emittery();

appInstance.mixin(toastMixin)
appInstance.use(globalMethods)

appInstance.use(store);
appInstance.use(router);

// Registrar el plugin WebSocket
appInstance.use(websocket);
appInstance.use(VueCleave);

appInstance.component('v-select', vSelect);
appInstance.component('v-lazy-image', VLazyImage);
appInstance.component('VueDatePicker', VueDatePicker);
appInstance.component(Skeletor.name, Skeletor);

appInstance.use(VueSweetalert2);
appInstance.use(Toaster);
appInstance.use(vfmPlugin);

appInstance.use(ArgonDashboard);
appInstance.mount("#app");


let deferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e; // Store globally
});

// Function to trigger the install prompt manually
export function promptPWAInstall() {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      console.log("User choice:", choiceResult.outcome);
      deferredPrompt = null; // Reset after use
    });
  }
}